module.exports = "./img/cdd43e2432cc5142f216422eaddd43ac.jpg";